export default "__VITE_ASSET__BRHSxLR0__"